import { ReactComponent as TimeSVG } from "ressources/icons/landing/time.svg";
import { ReactComponent as CloudSVG } from "ressources/icons/landing/cloud.svg";

import { useTranslation } from "react-i18next";

import "./style.css";

export default function Main() {
    const { t } = useTranslation();

    const features = [
        {
            Icon: TimeSVG,
            title: t("landing-main4"),
            paragraphs: [
                t("landing-main5"),
                t("landing-main6"),
                t("landing-main7"),
            ],
        },
        {
            Icon: CloudSVG,
            title: t("landing-main12"),
            paragraphs: [
                t("landing-main13"),
                t("landing-main14"),
                t("landing-main15"),
                t("landing-main16"),
            ],
        },
    ];

    return (
        <section className="main-landing">
            <div className="features-grid">
                {features.map(({ Icon, title, paragraphs }, idx) => (
                    <article className="feature-card" key={idx}>
                        <div className="feature-icon">
                            <Icon />
                        </div>
                        <h3 className="feature-title">{title}</h3>
                        <div className="feature-content">
                            {paragraphs.map((p, i) => (
                                <p key={i}>{p}</p>
                            ))}
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}
